export * from '../src/views/w3m-transactions-view/index.js';
//# sourceMappingURL=transactions.js.map